import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

//  Form to create new ConfigKey object
export default function ConfigKeyNew() {

    const navigate = useNavigate(); 
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [configKeyData, setConfigKeyData] = useState([]);
    const [configKeyList, setConfigKeyList] = useState([]);

    const [definitionId, setDefinitionId] = useState('');
    const [key, setKey] = useState('');
    const [displayKey, setDisplayKey] = useState('');
    const [order, setOrder] = useState('');

    const [postData, setPostData] = useState(false);
    const [selectedConfigKey, setSelectedConfigKey] = useState(null);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    const value_types = [
        { name: 'Boolean', code: 'BOOLEAN' },
        { name: 'Single Choice', code: 'SINGLE_CHOICE' },
        { name: 'Multi-Choice', code: 'MULTI_CHOICE' },
        { name: 'Integer Range', code: 'INTEGER_RANGE' }
    ];

    const [selectedValueType, setSelectedValueType] = useState(null);

    console.log('selectedValueType', selectedValueType);
    console.log('displayKey', displayKey);

    useEffect(() => {
        document.title = `ConfigKey | Palmona Pathogenomics`
    }, []);

    const nav_to_configdetail = (configId) => {
        const path = `/workflows/config/${configId}` ; 
        navigate(path);
    }

    useEffect(() => {

        if (!postData) return;

        let configKeyId = 0;

        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configkey`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                "definitionId": definitionId,
                "key": key,
                "DisplayKey": displayKey,
                "order": order,
                "value_type": selectedValueType.code
                })
            }).then((res) => res.json())
            .then(data => {
                setConfigKeyData(data);
                configKeyId = data.id;

                if (configKeysToCopy) {
                    configKeysToCopy.forEach((configValue) => {
                        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue`, {
                            method: 'POST',
                            headers,
                            body: JSON.stringify({
                                "configkeyId": configKeyId,
                                "value": configValue.value,
                                "DisplayValue": configValue.DisplayValue,
                                "order": configValue.order
                                })
                            }).then((res) => res.json())
                            .then(data => {
                                setConfigKeyData(data);
                            }).catch((error) => {
                                console.log('Error in creating ConfigKey', error);
                            });
                    })
                };
            }).catch((error) => {
                console.log('Error in creating ConfigKey', error);
            }).finally(() => {
                setPostData(false);
                setDefinitionId('');
                setKey('');
                setDisplayKey('');
                setOrder('');
                nav_to_configdetail(configKeyId);
            });
    }, [postData])  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configkey`, {
            headers,
            }).then((res) => res.json())
            .then(data => {
                setConfigKeyList(data);
            }
            ).catch((error) => {
                console.log('Error in getting ConfigKeys', error);
            });
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    const [configKeysToCopy, setConfigKeysToCopy] = useState([]);

    useEffect(() => {
        if (!selectedConfigKey) return;

        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue/getbykey/${selectedConfigKey.id}`, {
            headers,
            }).then((res) => res.json())
            .then(data => {
                setConfigKeysToCopy(data);
            }
            ).catch((error) => {
                console.log('Error in getting ConfigKeys to Copy', error);
            });
    }, [selectedConfigKey])

    return (
        <>

        <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
            <div className="grid">
                <div className="col-12 lg:col-2">
                    <div className="text-900 font-medium text-xl mb-3">Create a New Config Key</div>
                    <p className="m-0 p-0 text-600 line-height-3 mr-3">Config Key and Config Value objects are added to the Workflow Definition to add information into the Workflow Execution environment.</p>
                </div>
                <div className="col-6 lg:col-10">
                    <div className="grid formgrid p-fluid">
                        <div className="field mb-4 col-12">
                            <label htmlFor="definitionid1" className="font-medium text-900">Definition Id</label>
                            {/* <InputText id="definitionid1" type="text" value={definitionId}  onChange={(e) => console.log(e) }/> */}
                            <InputText id="definitionid1" type="text" value={definitionId}  onChange={(e) => setDefinitionId(e.target.value)}/>
                        </div>
                        <div className="field mb-4 col-12">
                            <label htmlFor="key1" className="font-medium text-900">Key</label>
                            <InputText id="key1" type="text" value={key} onChange={(e) => setKey(e.target.value)} />
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="displaykey1" className="font-medium text-900">Display Key</label>
                            <InputText id="displaykey1" type="text" value={displayKey} onChange={(e) => setDisplayKey(e.target.value)}/>
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="order1" className="font-medium text-900">Display Order</label>
                            <InputText id="order1" type="text" value={order} onChange={(e) => setOrder(e.target.value)}/>
                        </div>

                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="valuetype1" className="font-medium text-900 mr-4">Select a Value Type For this ConfigKey  </label>
                            <Dropdown id="valuetype1" value={selectedValueType} onChange={(e) => setSelectedValueType(e.value)} options={value_types} optionLabel="name" 
                                placeholder="Select a Value Type" className="w-full md:w-14rem" />
                        </div>

                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="copy1" className="font-medium text-900 mr-4">(Optional) Select a ConfigKey to copy ConfigValues</label>
                            <Dropdown id="copy1" value={selectedConfigKey} onChange={(e) => setSelectedConfigKey(e.value)} options={configKeyList} optionLabel="key" placeholder="Select a ConfigKey" className="w-full md:w-14rem" />
                        </div>

                        <div className="col-12">
                            <Button label="Save Changes" className="w-auto mt-3" onClick={() =>  setPostData(true) }/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        </>
    )
}